/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ClearOutputsForAppSessionMutationVariables = Types.Exact<{
  appSessionId: Types.Scalars["AppSessionId"]["input"];
}>;

export type ClearOutputsForAppSessionMutation = {
  readonly __typename: "Mutation";
  readonly clearOutputsForAppSession: {
    readonly __typename: "AppSession";
    readonly id: c.AppSessionId;
  };
};

export const ClearOutputsForAppSessionDocument = /*#__PURE__*/ gql`
  mutation ClearOutputsForAppSession($appSessionId: AppSessionId!) {
    clearOutputsForAppSession(appSessionId: $appSessionId) {
      id
    }
  }
`;
export type ClearOutputsForAppSessionMutationFn = Apollo.MutationFunction<
  ClearOutputsForAppSessionMutation,
  ClearOutputsForAppSessionMutationVariables
>;

/**
 * __useClearOutputsForAppSessionMutation__
 *
 * To run a mutation, you first call `useClearOutputsForAppSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearOutputsForAppSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearOutputsForAppSessionMutation, { data, loading, error }] = useClearOutputsForAppSessionMutation({
 *   variables: {
 *      appSessionId: // value for 'appSessionId'
 *   },
 * });
 */
export function useClearOutputsForAppSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ClearOutputsForAppSessionMutation,
    ClearOutputsForAppSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ClearOutputsForAppSessionMutation,
    ClearOutputsForAppSessionMutationVariables
  >(ClearOutputsForAppSessionDocument, options);
}
export type ClearOutputsForAppSessionMutationHookResult = ReturnType<
  typeof useClearOutputsForAppSessionMutation
>;
export type ClearOutputsForAppSessionMutationResult =
  Apollo.MutationResult<ClearOutputsForAppSessionMutation>;
export type ClearOutputsForAppSessionMutationOptions =
  Apollo.BaseMutationOptions<
    ClearOutputsForAppSessionMutation,
    ClearOutputsForAppSessionMutationVariables
  >;
